import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { ArrowIcon, BackIcon } from '@/assets/icons';
import { ROUTES } from '@/constants';
import { useQueryParams } from '@/hooks';
import { cn } from '@/libs/utils';
import { getActionLinkUrl } from '@/utils/utils';

export default function BackButton({
  className,
  metadata,
  href = '/',
  showText = true,
}) {
  const { t } = useTranslation('menus');
  const location = useLocation();

  const { queryParamsString } = useQueryParams();

  const url =
    location.state?.backTo ||
    getActionLinkUrl({
      route: ROUTES.admin,
      resource: href,
      queryParams: queryParamsString,
    });

  return (
    <Link
      to={url}
      className={cn(
        'group absolute left-5 top-5 hidden h-9 gap-2 p-2 px-4 2xl:flex',
        className
      )}
    >
      <span
        className={cn(
          'flex items-center justify-center transition-all group-hover:-translate-x-1'
        )}
      >
        {showText ? (
          <BackIcon className={cn(metadata?.iconClassName)} />
        ) : (
          <ArrowIcon className={cn(metadata?.iconClassName)} />
        )}
      </span>

      <span className={cn(showText ? 'font-semibold' : 'sr-only')}>
        {t('back')}
      </span>
    </Link>
  );
}
